var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsOptional, IsBoolean, IsString, Matches, IsTimeZone, IsNotEmpty, } from 'class-validator';
export class UpdateInputDto {
    send_pulse;
    time;
    gmt;
}
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Object)
], UpdateInputDto.prototype, "send_pulse", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Matches(/\d{1,2}:\d{2}/),
    IsNotEmpty(),
    __metadata("design:type", Object)
], UpdateInputDto.prototype, "time", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsTimeZone(),
    IsNotEmpty(),
    __metadata("design:type", Object)
], UpdateInputDto.prototype, "gmt", void 0);
//# sourceMappingURL=owner-settings.js.map